export default __webpack_public_path__ + "static/media/sqs.8bb15f44.svg";